// Autogenerated file
export const universalDocumentStatusesEnum = {
    Created: "Created",
    AwaitingPayment: "AwaitingPayment",
    Paid: "Paid",
    AwaitingToSignByCounterparty: "AwaitingToSignByCounterparty",
    SignedByCounterparty: "SignedByCounterparty",
    Canceled: "Canceled",
    Completed: "Completed",
    Outdated: "Outdated",
};
export const universalDocumentStatuses = [
    { label: "Создан", value: "Created" },
    { label: "Ожидает оплаты", value: "AwaitingPayment" },
    { label: "Оплачен", value: "Paid" },
    { label: "Ожидает подписи контрагентом", value: "AwaitingToSignByCounterparty" },
    { label: "Подписан контрагентом", value: "SignedByCounterparty" },
    { label: "Аннулирован", value: "Canceled" },
    { label: "Документооборот завершен", value: "Completed" },
    { label: "Заменен версией новее", value: "Outdated" },
];
